import React from 'react';
import { DebounceInput } from 'react-debounce-input';

/**
 * A version of react-input-range that deounce the onChange callback
 * to avoid to many calls to the server
 */
const SearchBoxDebounced = ({
  value,
  placeholder,
  disabled,
  disabledText,
  onChange,
}) => {
  return (
    <DebounceInput
      placeholder={disabled ? disabledText : placeholder}
      minLength={2}
      debounceTimeout={500}
      value={value}
      disabled={disabled}
      onChange={event => onChange && onChange(event.target.value)}
    />
  );
};

export default SearchBoxDebounced;
